import React, { FC } from 'react'

type Props = {
  size?: number | string
  color?: string
}

const Reply: FC<Props> = ({ size = 24, color = '#309BEC' }) => {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" width={size} height={size}>
      <path d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" fill={color}></path>
    </svg>
  )
}

export default Reply
